export class DialogModelNewDisease {
    constructor(
      public data:any
    ) {}
  }